export const createPoints = () => [
  { x: 0.5, y: 0.2, angle: 0, speed: 0.0003, orbitRadius: 0.08, centerX: 0.5, centerY: 0.2, radius: 0.4 },
  { x: 0.3, y: 0.3, angle: Math.PI / 2, speed: 0.0002, orbitRadius: 0.06, centerX: 0.35, centerY: 0.28, radius: 0.35 },
  { x: 0.7, y: 0.3, angle: Math.PI, speed: 0.00025, orbitRadius: 0.07, centerX: 0.65, centerY: 0.28, radius: 0.35 },
  { x: 0.5, y: 0.15, angle: Math.PI * 1.5, speed: 0.00015, orbitRadius: 0.05, centerX: 0.5, centerY: 0.18, radius: 0.5 },
];

export const stepMotion = (points, mouse, scroll, fullHeight, palette) => {
  mouse.x += (mouse.targetX - mouse.x) * 0.15;
  mouse.y += (mouse.targetY - mouse.y) * 0.15;
  scroll.current += (scroll.target - scroll.current) * 0.05;
  const scrollOffset = (scroll.current / fullHeight) * 0.3;
  const tiltX = (mouse.x - 0.5);
  const tiltY = (mouse.y - 0.5) * 0.5;
  const positions = [];
  const colors = [];
  const radii = [];
  for (let i = 0; i < points.length; i++) {
    const point = points[i];
    point.angle += point.speed;
    const baseX = point.centerX + Math.cos(point.angle) * point.orbitRadius;
    const baseY = point.centerY + Math.sin(point.angle) * point.orbitRadius;
    const dx = mouse.x - baseX;
    const dy = mouse.y - baseY;
    const pull = 0.25 * Math.max(0, 1 - Math.sqrt(dx * dx + dy * dy) * 2);
    point.x = baseX + dx * pull + tiltX * 0.25;
    point.y = baseY + dy * pull + tiltY * 0.25 + scrollOffset * (1 - point.radius);
    const rgb = palette[i];
    positions.push(point.x, point.y);
    colors.push(rgb[0] / 255, rgb[1] / 255, rgb[2] / 255);
    radii.push(point.radius);
  }
  return { positions, colors, radii };
};
